/** @jsxImportSource @emotion/react */
import NotFound from "@/components/common/404";
import { RouterErrorFallback } from "@/components/common/RouterErrorFallback";
import { AuthProvider, useAuth } from "@/lib/authProvider";
import { queryClient } from "@/lib/react-query";
import { protectedRoutes } from "@/routes/protected";
import { Box, CircularProgress } from "@mui/material";
import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from "@tanstack/react-query";
import * as React from "react";
import { HelmetProvider } from "react-helmet-async";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    element: <Outlet />,
    errorElement: <RouterErrorFallback />,
    children: [...protectedRoutes, { path: "*", element: <NotFound /> }],
  },
]);

const tanstackQueryClient = new QueryClient();

export const AppProvider = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

const AppContent = () => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TanstackQueryClientProvider client={tanstackQueryClient}>
      <QueryClientProvider client={queryClient}>
        <React.Suspense fallback={<CircularProgress />}>
          <HelmetProvider>
            {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore index access だとビルド時に変換されない
              process.env.NODE_ENV !== "test" && <ReactQueryDevtools />
            }
            <RouterProvider router={router} />
          </HelmetProvider>
        </React.Suspense>
      </QueryClientProvider>
    </TanstackQueryClientProvider>
  );
};
